import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"


import { IonItem, IonLabel, IonInput } from "@ionic/vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'MicrochipInput',
  props: {
    microchipId: null
  },
  emits: ["update:microchipId"],
  setup(__props: any) {



const vFocus = {
  mounted: (el: any) => el.focus()
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonItem), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonLabel), { position: "stacked" }, {
        default: _withCtx(() => [
          _createTextVNode("マイクロチップ番号")
        ]),
        _: 1
      }),
      _withDirectives(_createVNode(_unref(IonInput), {
        type: "text",
        maxlength: 15,
        clearInput: true,
        autofocus: "",
        placeholder: "例:392148012345678",
        value: __props.microchipId,
        onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:microchipId', $event.target.value))),
        required: ""
      }, null, 8, ["value"]), [
        [vFocus]
      ])
    ]),
    _: 1
  }))
}
}

})